module.exports = __webpack_public_path__ + "static/media/noun-help.a93b0458.svg";